module.exports = __webpack_public_path__ + "img/go2.7f4ed126.png";